export const SMART_PAGE_DEFAULT_VALUES = {
  BUSINESS_NAME: _TL_('Business Name'),
  DESCRIPTION: _TL_('Briefly describe what your business offers. It\'s best to include keywords customers might use to find your products or services.'),
};
